/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { JSXElement, Component } from 'solid-js';
import { noShadowDOM } from 'solid-element';
import { BtnClasses } from '../../types/common';

export interface IPolicyToolTipAttributes {
  title: string;
  classname: string;
}

export interface FabButtonProps {
  icon: string;
  btnClass?: BtnClasses;
  fabClass?: string;
  alwaysDisplay?: boolean;
  disable?: boolean;
  policyToolTip?: IPolicyToolTipAttributes;
  isToolTipDisabled?: boolean;
}

const FabButton: Component<FabButtonProps> = (props): JSXElement => {
  noShadowDOM();

  const getIcon = () => props.icon || '';
  const getBtnClass = () => props.btnClass || 'primary';
  const getFabClass = () => props.fabClass || 'fab-button';
  const getAlwaysDisplay = () => props.alwaysDisplay || false;
  const getDisable = () => props.disable || false;
  const getIsToolTipDisabled = () => props.isToolTipDisabled !== false; // default true

  const handleClick = (event: MouseEvent) => {
    if (!getDisable()) {
      // Emit custom event for React wrapper component to consume
      const customEvent = new CustomEvent('fab-button-click', {
        detail: { originalEvent: event },
        bubbles: true,
      });
      (event.target as HTMLElement)?.dispatchEvent(customEvent);
    }
  };

  const getClassNames = (
    baseClass: string,
    conditionalClasses: Record<string, boolean>
  ) => {
    const classes = [baseClass];
    Object.entries(conditionalClasses).forEach(([className, condition]) => {
      if (condition) {
        classes.push(className);
      }
    });
    return classes.join(' ');
  };

  const fabDivClasses = () =>
    getClassNames(getFabClass(), {
      'd-flex d-lg-none': !getAlwaysDisplay(),
    });

  const buttonClasses = () =>
    getClassNames(`button ${getBtnClass()} icon-large-circle`, {
      disabled: getDisable(),
    });

  const tooltipTitle = () => {
    if (getIsToolTipDisabled() || !props.policyToolTip?.title) {
      return undefined;
    }
    return props.policyToolTip.title;
  };

  const tooltipClass = () => {
    return props.policyToolTip?.classname || '';
  };

  return (
    <div class={fabDivClasses()}>
      {/* Simplified tooltip wrapper - using native title attribute for basic tooltip */}
      <div title={tooltipTitle()} class={tooltipClass()}>
        <div>
          <button
            class={buttonClasses()}
            onClick={handleClick}
            disabled={getDisable()}
          >
            <i class={`icon-font ${getIcon()}`} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FabButton;
